// extracted by mini-css-extract-plugin
export var caption = "styles-module--caption--36760";
export var credit = "styles-module--credit--ff234";
export var video = "styles-module--video--fc4c1";